'use client'

import { DropdownMenuItem, type NavbarItemVariant, NavbarLink } from '@portal/taonga-ui'

import { css, cx } from '@news/styled-system/css'
import { getPublicEnv } from '@/shared/env'
import { useI18n } from '@/shared/providers'

export function SupportLink({ variant = 'default' }: { variant?: NavbarItemVariant }) {
    const runtimeEnv = getPublicEnv()
    const { i18n } = useI18n()
    const href = `${runtimeEnv.NEXT_PUBLIC_ZENDESK_URL}/requests/new`

    if (variant === 'default') {
        return (
            <NavbarLink href={href} className={css({ display: { base: 'none', xl: 'flex' } })}>
                {i18n.PORTAL_SUPPORT}
            </NavbarLink>
        )
    }

    return (
        <DropdownMenuItem href={href} target="_blank" rel="noopener noreferrer">
            <i className={cx('fa-light fa-comment-question', css({ color: 'success' }))} />
            &nbsp;{i18n.PORTAL_SUPPORT}
        </DropdownMenuItem>
    )
}
